import BaseService from '_services/rest/base';

/* eslint-disable new-parens */
class CommentService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/comment`;
  }

  getList(params) {
    const filters = { search: params.search, status: params.status };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  deleteComment(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  save(model) {
    return this.request(`${this.getUrl()}/${model.id}`, model, 'put')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }
}

export default new CommentService();
